import { useState } from "react";
import { sceneTabs, phraseList } from "@/mocks/dashan";

const sceneMeta: Record<string, string> = {
  all: "全部场景",
  first: "初次见面",
  cafe: "咖啡店&酒馆",
  gym: "健身房",
  commute: "通勤路上",
  party: "聚会社交",
  online: "线上开场",
};

export default function OpeningLibrary() {
  const [active, setActive] = useState("all");
  const filtered =
    active === "all" ? phraseList : phraseList.filter((p) => p.scene === active);

  return (
    <section id="opening" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <i className="ri-message-3-line"></i> 开场白话术库
            </span>
            <h3 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              别背台词，学会开场
            </h3>
            <p className="mt-3 text-foreground-600 max-w-2xl leading-relaxed">
              按场景挑一句，先读懂背后的「为什么」，再自然地说出口。好开场不是堆漂亮话，而是给对方一个舒服接话的台阶。
            </p>
          </div>
          <a
            href="#faq"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#faq")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1.5 whitespace-nowrap cursor-pointer"
          >
            想看更多技巧 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* 场景切换 Segmented Control */}
        <div
          className="mt-8 flex gap-2 overflow-x-auto pb-1"
          role="tablist"
          aria-label="按场景筛选话术"
        >
          {sceneTabs.map((t) => (
            <button
              key={t.id}
              role="tab"
              aria-selected={active === t.id}
              onClick={() => setActive(t.id)}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                active === t.id
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-200/70 text-foreground-700 hover:bg-background-300/70"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {filtered.map((p, i) => (
            <article
              key={p.line}
              className="group rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col hover:border-primary-300 hover:bg-background-100/40 transition-colors"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs">
                  <i className="ri-price-tag-3-line"></i> {sceneMeta[p.scene]}
                </span>
                <span className="inline-flex items-center gap-1 text-primary-600 text-xs font-medium">
                  <i className="ri-vip-crown-fill text-accent-500"></i> {p.score}
                </span>
              </div>

              <p className="mt-4 font-medium text-foreground-950">{p.title}</p>

              <blockquote className="mt-3 text-foreground-800 text-[15px] leading-relaxed border-l-[3px] border-primary-400 pl-3">
                “{p.line}”
              </blockquote>

              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                {p.note}
              </p>

              <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900">
                  <i className="ri-lightbulb-flash-line"></i> {p.tag}
                </span>
                <button
                  className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors"
                  aria-label="收藏这条话术"
                >
                  <i className="ri-bookmark-line"></i> 收藏
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}